import React, { FC, memo } from 'react'
import _sortBy from 'lodash/sortBy'
import _forEach from 'lodash/forEach'

import { WrapperSelectOptions } from './style'

import SelectOptions from 'components/SelectOptions'

type Props = {
  id?: string
  isDisabled?: boolean
  name: string
  width?: string
  selectValue?: string
  options?: any[]
  unassignTimePickerOptions?: any
  onChange: (value: string) => void
  hasClass?: boolean
  errorMessage?: any
  isError?: boolean
  displayValue?: string
  onMenuOpen?: () => void
}
const TimePickerDiffTime: FC<Props> = ({
  id,
  onChange,
  selectValue,
  options,
  name,
  width,
  hasClass,
  errorMessage,
  isError,
  displayValue,
  isDisabled = false,
  onMenuOpen,
}) => {
  const handleUpdateData = (selectValue: string): void => {
    onChange(selectValue)
  }

  const getOptionStyle = (provided: any, label: string) => {
    const isSelected = displayValue === label
    const hasTimeHighLight = new RegExp(/:00/).test(label)

    if (hasTimeHighLight) {
      return {
        ...provided,
        color: 'black',
        fontWeight: 'bold',
        fontSize: 16,
      }
    }

    return {
      ...provided,
      ...(isSelected && {
        color: 'black',
        fontWeight: 'bold',
      }),
    }
  }

  return (
    <WrapperSelectOptions>
      <SelectOptions
        id={id}
        width={width}
        name={name}
        className="mono-select__dropdown-indicator" // FIXME この指定があると時計マークが裏で描画されて、画面幅によってはチラ見えしてしまうため、削除したい
        options={options || []}
        selectValue={selectValue}
        handleUpdateData={handleUpdateData}
        hasClass={hasClass}
        errorMessage={errorMessage}
        isError={isError}
        isDisabled={isDisabled}
        onMenuOpen={onMenuOpen}
        styles={{
          option: (provided: any, { label }: { label: string }) => getOptionStyle(provided, label),
          menuPortal: (provided: any) => ({
            ...provided,
            zIndex: 99999,
            position: 'fixed'
          }),
          menu: (provided: any) => ({
            ...provided,
            zIndex: 99999,
          }),
          menuList: (provided: any) => ({
            ...provided,
            zIndex: 99999,
            backgroundColor: 'white',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
          }),
        }}
      />
    </WrapperSelectOptions>
  )
}

export default memo(TimePickerDiffTime)
